const keys = {
  PRECO_ABAIXO: {
    key: 'PRECO_ABAIXO',
  },
  PRECO_ACIMA: {
    key: 'PRECO_ACIMA',
  },
  PRECO_MUITO_ACIMA: {
    key: 'PRECO_MUITO_ACIMA',
  },
};

const values = Object.keys(keys)
  .map(key => keys[key]);

export default {
  keys,
  values,
};
